// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUISalePageView from 'xui/modules/storeWebsite/BaseUISalePageView'

export default class SalePageView extends BaseUISalePageView {}
